import 'core-js/es6';
import 'core-js/es7/reflect';
import 'zone.js/dist/zone';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { setAngularLib, UpgradeModule } from '@angular/upgrade/static';
import { AppModule } from './app.module';

import * as angular from 'angular';
import app from './app';

setAngularLib(angular);

document.addEventListener('DOMContentLoaded', event => {
    platformBrowserDynamic().bootstrapModule(AppModule).then(platformRef => {
        const upgrade = platformRef.injector.get(UpgradeModule) as UpgradeModule;
        upgrade.bootstrap(document.getElementById('app'), [app.name]);
    });
});
